import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { Modal, message } from "@/config/antd";
import Button from "@/components/common/Button";
import SuccessGif from "@/assets/images/veegil_loader/Success.gif";
import WebIcon from "../Web_Icons";

const Success = ({
  isVisible,
  onClose,
  header,
  paragraph,
  buttonText,
  recoveryPath,
  linkText,
  linkPath,
  copyLinkUrl,
  showCancelButton = false,
  cancelButtonText = "Cancel and go back",
  onButtonClick,
  onCancelClick,
}) => {
  const navigate = useNavigate();

  const handleCopyLink = async () => {
    if (!copyLinkUrl) return;
    try {
      await navigator.clipboard.writeText(copyLinkUrl);
      message.success("Link copied to clipboard");
    } catch {
      message.error("Failed to copy link");
    }
  };

  const handleLinkClick = () => {
    navigate(linkPath);
    onClose();
  };

  // const handleButtonClick = () => {
  //   if (onButtonClick) {
  //     onButtonClick();
  //   } else if (recoveryPath) {
  //     navigate(recoveryPath);
  //   }
  //   onClose();
  // };

  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    } else if (recoveryPath) {
      navigate(recoveryPath);
    }
    if (onClose && typeof onClose === "function") {
      onClose(); // Only call onClose if it's a function
    }
  };

  const handleCancelClick = () => {
    if (onCancelClick) {
      onCancelClick();
    } else {
      onClose();
    }
  };

  return (
    <Modal
      open={isVisible}
      onCancel={null}
      closeIcon={null}
      footer={null}
      centered
      width={350}
      styles={{
        body: { padding: 0 },
        content: {
          padding: 0,
          borderRadius: "16px",
          overflow: "hidden",
        },
        mask: { backgroundColor: "rgba(0, 0, 0, 0.75)" },
      }}
      className="custom-success-modal"
      data-testid="mock-modal">
      <div className="flex flex-col bg-white">
        <div className="p-6">
          <div className="mb-6 flex justify-center">
            <img
              src={SuccessGif}
              alt="Success Icon"
              data-testid="success-icon"
              style={{
                width: "200px",
                height: "200px",
                margin: "0 auto",
                display: "block",
              }}
            />
          </div>
          <h2 className="heading-regular font-semibold text-primary mb-3 text-center">
            {header}
          </h2>
          <p
            className="text-regular text-center text-darkGray mb-6"
            dangerouslySetInnerHTML={{ __html: paragraph }}
            data-testid="success-paragraph"
          />
          {copyLinkUrl && (
            <div
              className="w-full max-w-[350px] mx-auto flex items-center gap-[10px] h-[35px] px-[10px] rounded-[5px] border border-grey bg-softBlue mb-6"
              data-testid="copy-link-container">
              <button
                type="button"
                onClick={handleCopyLink}
                className="shrink-0 flex items-center justify-center text-primary hover:opacity-80"
                aria-label="Copy survey link">
                <WebIcon icon="BlueCopy" className="w-4 h-4 cursor-pointer" />
              </button>
              <span className="text-lightGrey text-small truncate flex-1 min-w-0 text-left">
                {copyLinkUrl}
              </span>
            </div>
          )}
        </div>

        <div className="w-full bg-secondary p-4 flex flex-col items-center">
          {linkText && linkPath && (
            <button
              onClick={handleLinkClick}
              className="text-darkGray underline text-sm mb-3"
              data-testid="additional-link">
              {linkText}
            </button>
          )}
          {buttonText && (
            <Button
              text={buttonText}
              onClick={handleButtonClick}
              color="primary"
              className="w-full mb-3 bg-primary text-white"
              isActive={true}
              data-testid={`button-${buttonText
                .toLowerCase()
                .replace(/\s+/g, "-")}`}
            />
          )}
          {showCancelButton && (
            <button
              onClick={handleCancelClick}
              className="text-darkGray underline font-bold text-sm"
              data-testid="cancel-button">
              {cancelButtonText}
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
};

Success.propTypes = {
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
  header: PropTypes.string,
  paragraph: PropTypes.string,
  buttonText: PropTypes.string,
  recoveryPath: PropTypes.string,
  linkText: PropTypes.string,
  linkPath: PropTypes.string,
  showCancelButton: PropTypes.bool,
  cancelButtonText: PropTypes.string,
  onButtonClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  copyLinkUrl: PropTypes.string,
};

export default Success;